import type { Client, RequestContext } from "../client";
import type { TagSetResource } from "../resources/tagSetResource";
import { BasicRepository } from "./basicRepository";
export class TagSetRepository extends BasicRepository<TagSetResource, TagSetResource> {
    constructor(client: Client, requestContext: RequestContext) {
        super("TagSets", client, requestContext);
    }
    sort(ids: string[]) {
        return this.client.put(this.requestContext, this.client.getLink("TagSetSortOrder"), ids);
    }
}
